export { default as Switch } from './Switch.vue'

/*
 * Canonical Switch.jsx only publishes `sm`/`md` (34×20/14 and 42×24/18) —
 * `lg` is (derived), continuing the same per-step deltas (w +8, h +4, k +4)
 * one step further: 50×28/22. Named `sm`/`md`/`lg` to match `DSInput`'s own
 * `SIZE_CLASS` sizing vocabulary, not because the pixel values line up —
 * a switch this size next to an `lg` input isn't the same height, it's the
 * same size *tier*.
 *
 * The 3px inset (the border width) stays constant across all three: the
 * canonical spec keeps `top: (h - k) / 2` at 3px for both its published
 * sizes, so only the track/thumb dimensions scale, never the border.
 */
export const SIZE_CLASS = {
  sm: {
    root: 'h-4 w-6.5',
    thumb: 'size-2.5 data-[state=checked]:translate-x-2.5',
  },
  md: {
    root: 'h-5 w-8.5',
    thumb: 'size-3.5 data-[state=checked]:translate-x-3.5',
  },
  lg: {
    root: 'h-6 w-10.5',
    thumb: 'size-4.5 data-[state=checked]:translate-x-4.5',
  },
} as const

export type SwitchSize = keyof typeof SIZE_CLASS
